var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 9,
    viewBox: "0 0 41 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9243 4.92426C40.1586 4.68995 40.1586 4.31005 39.9243 4.07574L36.1059 0.257359C35.8716 0.0230446 35.4917 0.0230446 35.2574 0.257359C35.023 0.491674 35.023 0.871573 35.2574 1.10589L38.6515 4.5L35.2574 7.89411C35.023 8.12843 35.023 8.50833 35.2574 8.74264C35.4917 8.97696 35.8716 8.97696 36.1059 8.74264L39.9243 4.92426ZM0 5.1H0.9875V3.9H0V5.1ZM2.9625 5.1H4.9375V3.9H2.9625V5.1ZM6.9125 5.1H8.8875V3.9H6.9125V5.1ZM10.8625 5.1H12.8375V3.9H10.8625V5.1ZM14.8125 5.1H16.7875V3.9H14.8125V5.1ZM18.7625 5.1H20.7375V3.9H18.7625V5.1ZM22.7125 5.1H24.6875V3.9H22.7125V5.1ZM26.6625 5.1H28.6375V3.9H26.6625V5.1ZM30.6125 5.1H32.5875V3.9H30.6125V5.1ZM34.5625 5.1H36.5375V3.9H34.5625V5.1ZM38.5125 5.1H39.5V3.9H38.5125V5.1Z",
    fill: "#2D2946"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/ArrowIcon.64f93ce5e1772f08aaa5975e6ff752f5.svg";
export { ForwardRef as ReactComponent };